import { memo } from 'react';
import { cn } from 'root/src/client/v2/common/helpers/cn';
// Percentage of `total` that `part` represents, clamped to 0-100 and rounded. Returns 0 rather than
// NaN when there is nothing to divide by, which the legacy bars rendered as an invalid `width: NaN%`.
export const toPercentage = (part, total) => (total > 0 ? Math.min(100, Math.max(0, Math.round((part / total) * 100))) : 0);
// The redesign's meter. Shared by the drop details card (points, initial reward) and the dare cards
// (reward capacity) so every bar reads the same.
export const ProgressBar = memo(({ value, className, barClassName }) => (<div className={cn('h-1.5 overflow-hidden rounded-full bg-secondary', className)}>
		<div className={cn('h-full rounded-full bg-gradient-teal', barClassName)} style={{ width: `${Math.min(100, Math.max(0, value))}%` }}/>
	</div>));
